import { connect } from "react-redux";
import { PacienteViewProps, mapDispatchToPacienteProps, mapStateToPacienteProps } from "../paciente.controller";
import { FilterPaciente, initialValuePaciente, Paciente } from "../paciente.model";
import { Select as ViewList } from "../../../components/select";
import { Box, Chip, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { PacienteCadastro } from "./paciente.cad";
import { formatDataTime, formatTime, isEmpty, listDataText } from "../../../services/utils";
import { Search } from "@mui/icons-material";
import { handleShowSelecionarMedico } from "../../medico/view/medico.select";
 
export const columnsPaciente: GridColDef[] = [
    { field: 'dt_hr_chegada', headerName: 'Chegou as', flex: 1, valueFormatter:(value,row:Paciente)=>formatTime(row.dt_hr_chegada) },
    { field: 'nome', headerName: 'Paciente', flex: 1 },
    { field: 'atendimento.medico', headerName: 'Medico', flex: 1, valueFormatter:(value,row:Paciente)=>row.atendimento.medico.nome },
    { field: 'situacao', headerName: 'Situação', flex: 1, renderCell:(prm)=>{
        switch (prm.value) {
            case "AGUARDANDO":
                return <Chip label={"Aguardando"} color="error" />
            case "CHAMADO":
                return <Chip label={"Chamando"} color="success" />
            default:
                return <Chip label={"Finalizado"} color="info" />
        }
    } },
    { field: 'dt_hr_saida', headerName: 'Saiu as ', flex: 1, valueFormatter:(value,row:Paciente)=>isEmpty(row.dt_hr_saida)?"":formatTime(row.dt_hr_saida)},

]

const listDataOpt = listDataText();

function PacienteList(props: PacienteViewProps) {
    const { pacienteActions,pacienteState } = props
    const { error, loadingRows, msg, row, rows, showAlert, showDialogExluir, status,showCadModal,changeList, filtro } = pacienteState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue,setShowCadModal, setFiltro } = pacienteActions
    console.log("PacienteList props ",props)

    const [showFormFiltro, setShowFormFiltro] = useState(false)
    const [hiddenFieldDataFiltro, setHiddenFieldDataFiltro] = useState(true);


    useEffect(()=>{
        if(rows.length === 0)
            setFiltro(filtro)
    },[])

    const handleNovo = () => {
        set({
            ...initialValuePaciente,
            dt_hr_chegada: new Date().toISOString()
        })
        setShowCadModal(true)
        handleShowSelecionarMedico(true)
    }

    const handleAlterar = (row: any) => {
        console.log("chamou handleAlterar")
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        console.log("chamou handleCloseCadastro")
        setShowCadModal(false)
    }


    const handleMutatorFiltro = ([value, field]: any, state: any, { changeValue }: any) => {
        console.log("field", field)
        console.log("value", value)
        var label = "";
        if (field === "opt_data_select") {
            console.log("existe definir",String(value['label']).toLowerCase().includes("definir",0))
            
            if (String(value['label']).toLowerCase().includes("definir",0)) {//verifica se é um valor personalizado
                //changeValue(state, 'dtIni', () => value['value']['dtIni']);
                //changeValue(state, 'dtFim', () => value['value']['dtFim']);
                //changeValue(state, 'show_data_label', () => value['label']);
                //changeValue(state, 'show_data_label', () => "De: " + getDataText(value['value']['dtIni']) + " Até: " + getDataText(value['value']['dtFim']));
                label = "De: " + formatDataTime(value['value']['dtIni']) + " Até: " + formatDataTime(value['value']['dtFim'])                
                setHiddenFieldDataFiltro(false);
            } else {
                label = value['label'];
                setHiddenFieldDataFiltro(true);
            }
            //alterar diretamente no filtro, por causa do useState local setHiddenFieldDataFiltro, que atualiza o react e o changeValue nao tem modificacao
            setFiltro({...filtro,dtIni:value['value']['dtIni'],dtFim:value['value']['dtFim'],opt_data_select:value['label'],show_data_label:label})
        } else {
            if (field === "dtIni" || field === "dtFim") {
                label = "De: " + formatDataTime(state.formState.values.dtIni) + " Até: " + formatDataTime(state.formState.values.dtFim)
                changeValue(state, 'show_data_label', () => label);
            }
            changeValue(state, field, () => value)
        }

    }    

    const handleFiltroSubmit = (value: FilterPaciente) => {
        console.log("handleFiltroSubmit", value);
        setFiltro(value)
        setShowFormFiltro(false);
    }    

    function Cadastro() {
        return PacienteCadastro({
            ...props,
            handleCloseView: handleCloseCadastro
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: showCadModal,
            heigth: "auto",
            width:"md"
        })
    }

    const List = ()=>{
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Pacientes a serem chamados"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"nome"}
                orderBy="dt_hr_chegada"
                columns={columnsPaciente}
                rows={rows}
                loading={loadingRows}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick:()=>setFiltro(filtro)
                }}
                ListItemTextPrimary={(row: Paciente) => <Typography component={"span"}>{row.nome}</Typography>}
                showFullFiltroForm={true}
                fullFiltroFormParams={{
                    showFormFiltro: showFormFiltro,
                    listFieldShow: [
                        { label: "Período: ", name: "show_data_label", handleOnClick: () => setShowFormFiltro(true) },

                    ],
                    form: {
                        contentForm: [
                            { fieldName: "opt_data_select", label: "Periodo das vendas", type: "autocomplete", key: "opt_data_select", colunsXS: 12, colunsSM: 12, colunsMD: 6, list: listDataOpt, handleChangeMutator: (mutator, values, formValues) => mutator(values, "opt_data_select") },
                            { fieldName: "dtIni", label: "Data de:", type: "data", key: "dtIni", colunsXS: 12, colunsSM: 6, colunsMD: 3, hidden:()=> hiddenFieldDataFiltro, handleChangeMutator: (mutator, values, formValues) => mutator(values, "dtIni") },
                            { fieldName: "dtFim", label: "Até:", type: "data", key: "dtFim", colunsXS: 12, colunsSM: 6, colunsMD: 3, hidden:()=> hiddenFieldDataFiltro, handleChangeMutator: (mutator, values, formValues) => mutator(values, "dtFim") },
                            { fieldName: "show_data_label", label: "Data Text", type: "text", key: "show_data_label", colunsXS: 12, colunsSM: 12, colunsMD: 6, hidden:()=> true },
                        ],
                        buttonActions: [
                            { label: "Aplicar Filtro", icon: <Search />, color: "primary", variant: "outlined", type: "submit", disableType: "padraoForm" },
                        ],
                        row: filtro,
                        handleMutator: handleMutatorFiltro,
                        handleOnSubmit: handleFiltroSubmit,
                        handleCancel: () => { },

                    }
                }}
                handleShowFiltroForm={() => setShowFormFiltro(!showFormFiltro)}

            />
        )
    }

    return (
        <div className="modulo">
            <Cadastro />
            <List />
        </div>
    )

}

export default connect(mapStateToPacienteProps,mapDispatchToPacienteProps)(PacienteList);


